import { render, staticRenderFns } from "./ticker.vue?vue&type=template&id=287bef07&"
import script from "./ticker.vue?vue&type=script&lang=js&"
export * from "./ticker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports